import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './helpers/ApiHelper'

// partie authentification
import auth from './auth'

// check auth
auth.checkAuth()

Vue.config.productionTip = false

// api à disposition
Vue.mixin({
  data: function () {
    return {
      api: api
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// développeur
if (process.env.NODE_ENV === 'development') {
  store.commit('setJwt', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwibmFtZSI6IkRhbWllbiBKb3N0IiwiZW1haWwiOiJkYXdhZGFtQGdtYWlsLmNvbSIsInJvbGUiOiJTVVBFUl9BRE1JTiIsImlzU3VwZXJBZG1pbiI6dHJ1ZSwiaXNBZG1pbiI6dHJ1ZSwiaWF0IjoxNTUzODEwODc5fQ.eG6Vtrbna3hIRJm7KuuF203JVV9rQbNjLXlLCdCzwMU')
}
